import Axios from "axios";
import React, { Component } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    NavLink,
    useParams,
    useRouteMatch,
    useHistory,
    Redirect,
} from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import { QRCode } from "react-qrcode-logo";
import hoistStatics from "hoist-non-react-statics";
import Func from "../../functions";
import Loading from "../../layouts/Loading";
import Env from "../../env";

let runInterval = null;

class EasypaisaMix extends Component {
    constructor(props) {
        super(props);
        this.state = {
            qrCodeId: Date.now().toString(),
        };
    }

    componentDidMount = async () => {
        this.props.i18n.changeLanguage(this.props.lngName);
    };

    setLoading = (v) => {
        this.setState({ isLoading: v });
    };

    copyClick = (element) => {
        $("#" + element).trigger("click");
    };

    showAlertInfo = (type) => {
        let title = "";
        let content = "";

        switch (type) {
            case "payer":
                title = this.props.t("Cashier.EasyPaisaPayerAccount");
                content = this.props.t("Cashier.EasyPaisaPayerContent");
                break;
            case "postscript":
                title = this.props.t("Cashier.Postscript");
                content = this.props.t("Cashier.PostscriptContent");
                break;
            case "amount":
                title = this.props.t("Cashier.Amount");
                content = this.props.t("Cashier.AmountContent1");
                content += "<br />";
                content += this.props.t("Cashier.AmountContent2");
                break;
            case "card_no":
                title = this.props.t("Cashier.ReceiveEasyPaisaAccount");
                content = this.props.t("Cashier.CardNumberContent");
                break;
        }

        Func.swalAlert(title, content, "info", "10000");
    };

    render() {
        let showPostScriptStyle = this.props.styles.displayNormal;
        if (!this.props.data.detail.postscript) {
            showPostScriptStyle = this.props.styles.displayNone;
        }
        let showPayerNameStyle = this.props.styles.displayNormal;
        if (!this.props.data.payerName) {
            showPayerNameStyle = this.props.styles.displayNone;
        }

        let inputEndRadius = this.props.styles.inputEndRadius;

        let gcashMixStyle = {
            tagLabel: {
                color: "#fff",
            },
            tagBtnMemoBgColor: {
                background: "#fff",
            },
            tagContentTextShadow: {
                textShadow: "#dc3545 0px 0px 0px",
            },
        };

        return (
            <div>
                <div className="form-group row" style={showPayerNameStyle}>
                    <label className="col-sm-12 col-form-label text-sm">
                        {this.props.t("Cashier.EasyPaisaPayerAccount")}
                        <i
                            class="fas fa-question-circle"
                            style={this.props.styles.labelIconMarginLeft}
                            onClick={() => this.showAlertInfo("payer")}
                        ></i>
                    </label>
                    <div
                        className="col-sm-12"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <input
                            id="payerName"
                            name="payerName"
                            className="form-control form-control-sm"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.payerName}
                            readOnly
                        />
                    </div>
                </div>
                <div className="form-group row" style={showPostScriptStyle}>
                    <label className="col-sm-12 col-form-label text-sm">
                        {this.props.t("Cashier.Postscript")}
                        <i
                            class="fas fa-question-circle"
                            style={this.props.styles.labelIconMarginLeft}
                            onClick={() => this.showAlertInfo("postscript")}
                        ></i>
                    </label>
                    <div
                        className="input-group col-sm-12"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <input
                            id="postscript"
                            name="postscript"
                            className="form-control form-control-sm"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.data.detail.postscript}
                            onClick={(e) => this.props.copyData(e)}
                            readOnly
                        />
                        <div className="input-group-append">
                            <div
                                className="input-group-text"
                                // style={inputEndRadius}
                                onClick={() => this.copyClick("postscript")}
                            >
                                <span className="fas text-xs">Copy</span>
                            </div>
                        </div>
                        {/* <div className="input-group text-danger text-xs">
                            {this.props.t("Cashier.PostscriptContent")}
                        </div> */}
                    </div>
                </div>
                <div
                    className="form-group row"
                    style={this.props.styles.rowMarginBottom}
                >
                    <label className="col-sm-12 col-form-label text-sm">
                        {this.props.t("Cashier.Amount")}
                        <i
                            class="fas fa-question-circle"
                            style={this.props.styles.labelIconMarginLeft}
                            onClick={() => this.showAlertInfo("amount")}
                        ></i>
                    </label>
                    <div
                        className="input-group col-sm-12"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <input
                            id="amount"
                            name="amount"
                            className="form-control form-control-sm"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.data.amount}
                            onClick={(e) => this.props.copyData(e)}
                            readOnly
                        />
                        <div className="input-group-append">
                            <div
                                className="input-group-text"
                                // style={inputEndRadius}
                                onClick={() => this.copyClick("amount")}
                            >
                                <span className="fas text-xs">Copy</span>
                            </div>
                        </div>
                        {/* <div className="input-group text-danger text-xs">
                            {this.props.t("Cashier.AmountContent1")}
                            <br />
                            {this.props.t("Cashier.AmountContent2")}
                        </div> */}
                    </div>
                </div>
                {/* <div
                    className="form-group row"
                    style={this.props.styles.rowMarginBottom}
                >
                    <label className="col-sm-4 col-form-label text-sm">
                        {this.props.t("Cashier.BankName")}
                    </label>
                    <div
                        className="input-group col-sm-12"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <input
                            id="bank_name"
                            name="bank_name"
                            className="form-control form-control-sm"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.data.detail.bank}
                            onClick={(e) => this.props.copyData(e)}
                            readOnly
                        />
                        <div className="input-group-append">
                            <div
                                className="input-group-text"
                                onClick={() => this.copyClick("bank_name")}
                            >
                                <span className="fas text-xs">Copy</span>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* <div
                    className="form-group row"
                    style={this.props.styles.rowMarginBottom}
                >
                    <label className="col-sm-4 col-form-label text-sm">
                        {this.props.t("Cashier.BankBranch")}
                    </label>
                    <div
                        className="input-group col-sm-12"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <input
                            name="bank_branch"
                            className="form-control form-control-sm"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.data.detail.bank_branch}
                            onClick={(e) => this.props.copyData(e)}
                            readOnly
                        />
                        <div className="input-group-append">
                            <div className="input-group-text">
                                <span className="fas fa-university"></span>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div
                    className="form-group row"
                    style={this.props.styles.rowMarginBottom}
                >
                    <label className="col-sm-12 col-form-label text-sm">
                        {this.props.t("Cashier.ReceiveEasyPaisaAccount")}
                        <i
                            class="fas fa-question-circle"
                            style={this.props.styles.labelIconMarginLeft}
                            onClick={() => this.showAlertInfo("card_no")}
                        ></i>
                    </label>
                    <div
                        className="input-group col-sm-12"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <input
                            id="card_no"
                            name="card_no"
                            className="form-control form-control-sm"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.data.detail.card_no}
                            onClick={(e) => this.props.copyData(e)}
                            readOnly
                        />
                        <div className="input-group-append">
                            <div
                                className="input-group-text"
                                // style={inputEndRadius}
                                onClick={() => this.copyClick("card_no")}
                            >
                                <span className="fas text-xs">Copy</span>
                            </div>
                        </div>
                        {/* <div className="input-group text-danger text-xs">
                            {this.props.t("Cashier.CardNumberContent")}
                        </div> */}
                    </div>
                </div>
                {/* <div
                    className="form-group row"
                    style={this.props.styles.rowMarginBottom}
                >
                    <label className="col-sm-12 col-form-label text-sm">
                        {this.props.t("Cashier.CardName")}
                    </label>
                    <div
                        className="input-group col-sm-12"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <input
                            name="card_owner"
                            className="form-control form-control-sm"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.data.detail.card_owner}
                            onClick={(e) => this.props.copyData(e)}
                            readOnly
                        />
                        <div className="input-group-append">
                            <div className="input-group-text">
                                <span className="fas fa-user"></span>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
        );
    }
}

export default hoistStatics(withTranslation()(EasypaisaMix), EasypaisaMix);
